import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { Summary } from './Summary.js';

const SummaryContainer = ({ isReadOnly , hasSubscription , donationAmount  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Summary, {
        summaryLabel: getLabel('cart.discount.summary'),
        isReadOnly: isReadOnly,
        hasSubscription: hasSubscription,
        donationAmount: donationAmount
    });
};

export { SummaryContainer };
//# sourceMappingURL=SummaryContainer.js.map
